import HomePage from './HomePage';
export {default as route} from './route';

export default HomePage;
